import moment from "moment";

export const useFromNowDate = (date, ISO) => {
  moment.locale(ISO);
  const dateOBJ = date && moment(date).fromNow();
  return dateOBJ;
};
